module.exports = __webpack_public_path__ + "static/media/pdr1.bbf99ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/teacher_resources/pdr1.png
// module id = 1230
// module chunks = 0